import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { QpInfoComponent } from './qp-info.component';
const routes: Routes = [{ path: '', component: QpInfoComponent }];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QpRoutingModule { }
